export const FORM_NAME = 'login';



// WEBPACK FOOTER //
// ./src/login/constants.js